import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar/navbar.component';
import { SearchBoxComponent } from './search-box/search-box.component';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ListResultsComponent } from './list-results/list-results.component';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { PasswordModule } from 'primeng/password';
import { FooterComponent } from './footer/footer.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RouterModule } from '@angular/router';
import { BoxResultsComponent } from './box-results/box-results.component';
import { SkeletonModule } from 'primeng/skeleton';
import { MenubarModule } from 'primeng/menubar';
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from 'primeng/button';
import { CommentsComponent } from './comments/comments.component';
import { CardModule } from 'primeng/card';
import { TreeModule } from 'primeng/tree';
import { PanelModule } from 'primeng/panel';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ImageModule } from 'primeng/image';
import { GalleriaModule } from 'primeng/galleria';
import { Ai_boxComponent } from './ai_box/ai_box.component';

@NgModule({
  declarations: [
    NavbarComponent,
    SearchBoxComponent,
    ListResultsComponent,
    FooterComponent,
    BoxResultsComponent,
    CommentsComponent,
    Ai_boxComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    RouterModule,
    ReactiveFormsModule,
    InputTextareaModule,
    DialogModule,
    ToastModule,
    PasswordModule,
    ProgressSpinnerModule,
    SkeletonModule,
    MenubarModule,
    InputTextModule,
    ButtonModule,
    TreeModule,
    PanelModule,
    CardModule,
    AvatarModule,
    AvatarGroupModule,
    ImageModule,
    GalleriaModule
  ],
  exports: [
    NavbarComponent,
    SearchBoxComponent,
    ListResultsComponent,
    FooterComponent,
    BoxResultsComponent,
    CommentsComponent,
    Ai_boxComponent
  ]
})
export class ShareModule { }
